export default __webpack_public_path__ + "static/media/empty_tabInfo.c50e4bf5.svg";